import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import Notification from "../../Components/Notification/Notification";
import useHttpHook from "../../Hooks/HttpHook";
import { GetAllUserNotifications } from "../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const NotificationPage = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [notificationList, setNotificationList] = useState(null);

  useEffect(() => {
    getAllUserNotifications(1);
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getAllUserNotifications = async (page = 1) => {
    try {
      const res = await sendRequest(
        `${GetAllUserNotifications}?page=${page}`,
        {
          method: "GET",
        }
      );
      if (res.status === 1) {
        if (page === 1) {
          setNotificationList(res);
        } else {
          setNotificationList((prevState) =>
            createObjectForPaginatedResult(res, prevState, "paginate")
          );
        }
      }
    } catch (err) {
      console.log({ error: err });
    }
  };

  return (
    <Layout activeMenuId="notifications">
      <Notification
        isError={error}
        getNotifications={getAllUserNotifications}
        isLoading={loading}
        notificationList={notificationList}
      />
    </Layout>
  );
};

export default NotificationPage;
